import Vue from "vue";
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  localize,
  setInteractionMode,
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import pt_BR from "vee-validate/dist/locale/pt_BR.json";

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

// O locale pt_BR da regra `length` não inclui "caracteres" no final — acrescenta.
pt_BR.messages.length = "O tamanho do campo {_field_} deve ser {length} caracteres.";

localize({
  pt_BR,
});

const timeValidator = (value) => {
  if (value.length < 5) return false;
  const [horas, minutos] = value.split(":").map((val) => parseInt(val, 10));
  return horas < 24 && minutos < 60;
};

extend("timeValidator", timeValidator);

extend("onlyNumbers", {
  validate: (value) => /^\d+$/.test(value),
  message: "Este campo aceita apenas números.",
});

extend("no_special_chars", {
  validate: (value) => /^[A-Za-zÀ-ÖØ-öø-ÿ0-9\s.,;:!?()\-/ºª'"]*$/.test(value),
  message: "O campo {_field_} não aceita caracteres especiais nem emojis.",
});

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
localize("pt_BR");
setInteractionMode("eager");
